<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { getSystemEnvironmentType } from '@/utils/systemEnvironment'

const { t } = useI18n()
const environmentType = getSystemEnvironmentType()

const environmentLabel = computed(() => {
  switch (environmentType) {
    case 'development':
      return t('common.labels.development')
    case 'testing':
      return t('common.labels.testing')
    default:
      return null
  }
})
</script>

<template>
  <p
    v-if="environmentLabel"
    class="mt-2 text-xs font-semibold tracking-[0.24em] text-red-700 uppercase dark:text-red-400"
  >
    {{ environmentLabel }}
  </p>
</template>
